import { useEventCartContext } from 'hb-react/shared/apps/Events/contexts/EventCartContext';
import { useRegistrationFlowContext } from 'hb-react/shared/apps/Events/contexts/RegistrationFlowContext';
import { displayNotif } from 'hb-react/shared/helpers/notifications';

export const useOnFreeTickets = () => {
  const { valuesStep2 } = useRegistrationFlowContext();
  const { resetAndCompleteCart } = useEventCartContext();

  const postFreeTickets = async ({ formData, onSuccess }) => {
    try {
      await resetAndCompleteCart({
        values: {
          recaptcha_response: formData?.recaptcha_response,
          ...valuesStep2,
        },
        receipt: formData.receipt,
      });

      onSuccess();
    } catch (error) {
      displayNotif(
        'error',
        error?.response?.data?.errors ||
          I18n.t('web.networks.events.bookings.booking_error'),
      );
    }
  };

  return { postFreeTickets };
};
